import { render, staticRenderFns } from "./WaybillItems.vue?vue&type=template&id=1924c844&scoped=true&"
import script from "./WaybillItems.vue?vue&type=script&lang=js&"
export * from "./WaybillItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924c844",
  null
  
)

export default component.exports